import React from "react";
import SectionHead from "../ui/SectionHead";
import SummaryBar from "../ui/SummaryBar";
import Input from "../ui/Input";

export default function ContactStep({
  summaryItems,
  answers,
  setField,
  onBack,
  onSubmit,
  submitLabel,
  submitIcon,
}) {
  return (
    <div>
      <SectionHead
        title="Kontaktformular"
        subtitle="Sie erhalten Ihr unverbindliches Angebot in Kürze per Mail."
      />

      <div className="mt-4">
        <SummaryBar items={summaryItems} />
      </div>

      <div className="mt-6">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <Input
            label="Name Ihrer Firma *"
            placeholder="Firmenname.."
            value={answers.company}
            onChange={(v) => setField("company", v)}
          />
          <Input
            label="Ansprechpartner:in *"
            placeholder="Ihr Name..."
            value={answers.contact}
            onChange={(v) => setField("contact", v)}
          />
          <Input
            label="Ihre E-Mailadresse *"
            placeholder="Ihre E-Mail..."
            type="email"
            value={answers.email}
            onChange={(v) => setField("email", v)}
          />
          <Input
            label="Ihre Rufnummer"
            placeholder="+49 ..."
            value={answers.phone}
            onChange={(v) => setField("phone", v)}
          />
        </div>

        <label className="mt-5 flex items-start gap-3 rounded-2xl border border-gray-200 bg-slate-50 p-4 text-sm text-slate-700">
          <input
            type="checkbox"
            className="mt-1 h-4 w-4 rounded border-slate-300 text-emerald-600 focus:ring-emerald-600"
            checked={!!answers.accept}
            onChange={(e) => setField("accept", e.target.checked)}
          />
          <span>
            Hiermit akzeptiere ich die{" "}
            <span className="font-semibold text-[#0b2b40] underline underline-offset-2">
              Datenschutzbestimmungen
            </span>{" "}
            *
          </span>
        </label>

        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <button
            type="button"
            onClick={onBack}
            className="inline-flex items-center justify-center rounded-xl border border-gray-200 bg-white px-5 py-3 text-sm font-semibold text-slate-800 hover:bg-slate-50"
          >
            Zurück
          </button>

          <button
            type="button"
            onClick={onSubmit}
            className="inline-flex items-center justify-center rounded-xl bg-[#0b2b40] px-6 py-3 text-sm font-semibold text-white shadow-sm shadow-emerald-600/20 hover:bg-[#0b2b40]/90"
          >
            {submitLabel}
            <span className="ml-2 inline-flex h-8 w-8 items-center justify-center rounded-lg bg-white/15">
              {submitIcon}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
